import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getDocsAttachments = async (docId) => {
  return await request.get(
    `/Docs/attachments/${docId}`,
    null,
    'При загрузке вложений произошла ошибка'
  );
};

const useDocsAttachmentsQuery = (docId, options = {}) =>
  useQuery(
    queryKeys.docsAttachments(docId),
    () => getDocsAttachments(docId),
    options
  );

export default useDocsAttachmentsQuery;
